import axios, { AxiosResponse } from "axios";
import useAuthHeaders from "hooks/useAuthHeader";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import { useQuery } from "react-query";
import { DashboardTopProductResponse } from "types/dashboard-top-product";

interface GetAllTopProduct extends AxiosResponse {
    data: DashboardTopProductResponse
}

const useTopProduct = () => {
    const signOut = useSignOut();
    const headers = useAuthHeaders();


    return useQuery<unknown, unknown, GetAllTopProduct>({
        queryKey: ['get-all-top-product'],
        queryFn: async () => {
            try {
                return await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/top/product`, { headers })
            } catch (err) {
                console.error(err);
                if (err?.response?.status === 401) signOut();
            }
        },
    })
}

export default useTopProduct;